import React from 'react';

const fmt = (cents: string | number): string =>
  `$${(parseFloat(String(cents)) / 100).toFixed(2)}`;

const ProductPrice = ({ product, templateName, isSuitKit = false }) => {
  // Use first available variant, fall back to first variant
  const variant =
    product.variants.find((v: any) => v.available) ?? product.variants[0];

  const productPrice = parseFloat(product.price || "0");
  const productCompareAtPrice = parseFloat(product.compare_at_price || "0");
  const isSale = productCompareAtPrice > productPrice && productCompareAtPrice > 0;
  const discountPercentage = isSale
    ? Math.round(((productCompareAtPrice - productPrice) * 100) / productCompareAtPrice)
    : 0;

  // Find automatic: tag for promotional label (e.g. "automatic:25% off applied at checkout")
  const automaticTag = (product.tags as string[] | undefined)?.find((tag: string) =>
    tag.startsWith("automatic:")
  );
  const promoLabel = automaticTag ? automaticTag.split(":").slice(1).join(":") : null;

  const variantPrice = parseFloat(String(variant.price || "0"));
  const variantCompareAtPrice = variant.compare_at_price
    ? parseFloat(String(variant.compare_at_price))
    : null;

  return (
    <div className="pdp-price stacked-price" data-prodify-price-container data-sale={isSale}>
      <div className="flex flex-row justify-between">
        <div className="price-container lg:flex lg:flex-col">
          <span className="sr-only">Regular Price</span>
          <span className={variantPrice !== 0 ? 'bp' : ''}>
            {variantPrice ? fmt(variantPrice) : ''}
          </span>
          {!!variantCompareAtPrice && variantCompareAtPrice !== 0 && (
            <span className="text-[12px] line-through text-[#BBBBBD] mr-[8px] lg:mr-0">
              {fmt(variantCompareAtPrice)}
            </span>
          )}
          {productCompareAtPrice > 0 && templateName === 'product' && (
            <div className="discount_percent text-xs top hidden">
              Save {discountPercentage}%
            </div>
          )}
        </div>
        {!isSuitKit && promoLabel && (
          <div className="max-w-2/3">
            <span className="b3 text-[#CDA176] text-xs text-right block">{promoLabel}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductPrice;

